<template>
  <el-scrollbar style="height:90%">
    <eco-tree
      :data="treeData"
      :props="defaultProps"
      :support-filter="supportFilter"
      :highlight-current="highlightCurrent"
      :default-expand-all="defaultExpandAll"
      node-key="id"
      :show-checkbox="showCheckbox"
      :render-content="renderContent"
      :expand-on-click-node="false"
      @refresh="handleRefresh"
      @node-click="handleNodeClick"
      @check="check"
      ref="ecoTree"
    >
      <!-- 作用域插槽：插槽prop -->
      <slot slot-scope="{ node, data }" :node="node" :data="data"></slot>
    </eco-tree>
  </el-scrollbar>
</template>

<script>
import oaTemplate from "@/api/oaTemplate.js";
export default {
  name: "fe-sys-type-tree",
  props: {
    buildKey: {
      type: Boolean,
      default: false
    },
    managePlanKey: {
      type: Boolean,
      default: false
    },
    supportFilter: {
      type: Boolean,
      default: false
    },
    highlightCurrent: {
      type: Boolean,
      default: false
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    renderContent: {
      type: Function
    },
    tabIndex: {
      type: String,
      default: () => "first"
    },
    activeName: {
      type: String,
      default: () => "first"
    }
  },
  data() {
    return {
      treeData: [
        {
          name: "全部模板",
          id: 0,
          children: []
        }
      ],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  methods: {
    handleNodeClick(node) {
      this.$emit("node-click", node);
    },
    check(data, checkedObj) {
      this.$emit("check", data, checkedObj);
    },
    loadData(cb) {
      oaTemplate.getPaTemplate(this.typeKey).then(data => {
        this.treeData[0].children = data;
        this.$emit("setTree", this.treeData);
        cb && cb();
      });
    },
    handleRefresh(cb) {
      this.loadData(cb);
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
<style lang="scss" scoped>
>>> .el-tree .el-tree__empty-block {
  margin: 20px 20px;
}

>>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
